<template>
  <div class="tt-user-email">
    <div class="tt-user-email__label">
      {{ $t('PersonalArea_views_email') }}
    </div>
    <div class="tt-user-email__value">
      <div v-if="email">
        {{ email }}
      </div>
      <div class="tt-user-email__toggle-button"
           @click="toggleModal"
           v-else>
        {{ $t('Cabinet_User_info_enter_detail') }}
      </div>
    </div>

    <transition name="fade">
      <div class="tt-user-email__modal-container"
           v-if="showModal">
        <div class="tt-user-email__modal">
          <div class="tt-icon-button"
               @click="toggleModal">
            <img src="@/assets/icons-new/close.svg">
          </div>

          <div class="tt-input-field">
            <label class="tt-input-field__label">
              {{ $t('PersonalArea_views_save_user_email') }}
            </label>
            <input class="tt-input-field__input"
                   :class="{ 'tt-input-field__input--invalid': errors.length }"
                   :placeholder="$t('PersonalArea_views_email')"
                   v-model="emailInput">
            <div class="tt-input-field__error"
                 v-for="(err, index) in errors"
                 :key="index">
              {{ err }}
            </div>
          </div>

          <button class="tt-button tt-button--primary"
                  @click="updateEmail">
            {{ $t('PersonalArea_views_btn2save_popup') }}
          </button>
        </div>

        <div class="tt-user-email__modal-backdrop"
             @click="toggleModal"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    email: null
  },
  data: () => ({
    emailInput: '',
    showModal: false,
    errors: []
  }),
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },
    updateEmail() {
      this.$store.dispatch('auth/updateUser', { email: this.emailInput })
        .then(response => {
          if (response.data.id !== undefined) {
            this.$store.commit('auth/SET_USER', response.data);
              this.toggleModal();
            }
          })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            this.errors = error.response.data.errors.email;
          }
        });
    }
  }
}
</script>

<style lang="sass" scoped>
@import "src/assets/styles-new/typography"
@import "src/assets/styles-new/colors"
@import "src/assets/styles-new/vars"

.tt-user-email
  display: flex
  flex-direction: column
  gap: 8px
  &__label
    font-size: $fs-small
    color: $dark-gray
  &__value
    font-size: $fs-medium
    font-weight: $fw-medium
  &__toggle-button
    color: $main
    cursor: pointer
  &__modal-container
    position: fixed
    z-index: $zi-fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
    display: flex
    align-items: center
    justify-content: center
  &__modal
    margin: 16px
    max-width: 400px
    position: relative
    z-index: $zi-modal
    background-color: $white
    border-radius: 8px
    overflow: hidden
    padding: 32px 24px 24px
    .tt-icon-button
      position: absolute
      top: 8px
      right: 8px
    .tt-button
      margin-top: 24px
  &__modal-backdrop
    position: absolute
    z-index: $zi-modal-backdrop
    width: 100%
    height: 100%
    background-color: rgba(0, 0, 0, 0.4)

@media screen and (max-width: $tablet-width)
  .tt-user-email
    gap: 6px

@media screen and (max-width: $mobile-width)
  .tt-user-email
    gap: 0
    &__value
      font-size: 1rem
</style>